export default {
  'profile.about': 'Acerca de',
  'profile.services': 'Servicios',
  'profile.gallery': 'Galería',
  'profile.reviews': 'Reseñas',
  'profile.contact': 'Contacto',
  'profile.rates': 'Tarifas',
  'profile.languages': 'Idiomas',
  'profile.attributes': 'Atributos',
  'profile.availability': 'Disponibilidad',
  'profile.send_message': 'Enviar Mensaje',
  'profile.save': 'Guardar',
  'profile.saved': 'Guardado',
  'profile.subscribe': 'Suscribirse',
  'profile.premium_content': 'Contenido Premium',
  'profile.tour_dates': 'Fechas de Gira',
  'profile.more_about_me': 'Más sobre mí',
  'profile.physical_attributes': 'Atributos Físicos',
  'profile.personal_info': 'Información Personal',
  'profile.subscription_required': 'Se requiere suscripción',
  'profile.upgrade_subscription': 'Actualizar Suscripción',
  'profile.rates_only_visible': 'Las tarifas solo son visibles para suscriptores',
  'profile.services_available': 'Servicios Disponibles',
  'profile.reviews_only_visible': 'Las reseñas solo son visibles para miembros Regular y VIP',
  'profile.subscription_unlock': 'Suscríbete para desbloquear contenido exclusivo',
  'profile.view_profile': 'Ver Perfil',
  'profile.message': 'Mensaje',
  'profile.verified': 'Verificado',
  'profile.online': 'En línea',
  'profile.touring': 'De gira',
  'profile.favorite': 'Añadir a Favoritos',
  'profile.unfavorite': 'Eliminar de Favoritos',
  'profile.tabs.about': 'Acerca de',
  'profile.tabs.services': 'Servicios',
  'profile.tabs.rates': 'Tarifas',
  'profile.tabs.contact': 'Contacto',
  'profile.various_durations': 'Varias Duraciones',
  'profile.no_services': 'No hay servicios listados',
  'profile.no_rates': 'No hay tarifas listadas',
  'profile.back': 'Volver',
  'profile.last_online': 'Última conexión',
  'profile.registration_date': 'Fecha de registro',
  'profile.total_views': 'Vistas totales',
  'profile.personal_information': 'Información Personal',
  'profile.sexual_details': 'Detalles Sexuales',
  'profile.available_services': 'Servicios Disponibles',
  'profile.working_hours': 'Horario laboral',
  'profile.about_me': 'Sobre Mí',
  'profile.call': 'Llamar',
  'profile.booking': 'Reservar',
  'profile.contact_availability': 'Contacto y Disponibilidad',
  'profile.years': 'años',
  'profile.no_phone_number': 'Sin número de teléfono',
  'profile.contact_through_message': 'Por favor, contactar por mensaje',
  'profile.added_to_favorites': 'Añadido a favoritos',
  'profile.removed_from_favorites': 'Eliminado de favoritos',
  'profile.profile_added_to_favorites': '{{name}} ha sido añadido/a a tus favoritos',
  'profile.profile_removed_from_favorites': '{{name}} ha sido eliminado/a de tus favoritos',
  'profile.generating_image': 'Generando imagen de perfil...',
  'profile.select_date': 'Seleccionar una fecha',
  'profile.select_time': 'Seleccionar una hora',
  'profile.confirm_booking': 'Confirmar Reserva',
  'profile.booking_confirmed': 'Reserva Confirmada',
  'profile.booking_error': 'Error en la Reserva',
  'profile.select_date_time': 'Por favor, selecciona una fecha y hora',
  'profile.booking_description': 'Reserva tu cita con esta escort',
  'profile.booking_with': 'Reserva con',
  'profile.booking_for': 'para el',
  'profile.booking_at': 'a las',
  'profile.no_availability': 'No hay disponibilidad en las próximas 24 horas',
  'profile.check_availability': 'Verificar Disponibilidad',
  
  // New translation keys
  'profile.public_view': 'Perfil',
  'profile.subscriber_view': 'Acceso Privado',
  'profile.private_media': 'Medios Privados',
  'profile.private_secrets': 'Secretos Privados',
  'profile.premium_services': 'Servicios Premium',
  'profile.unlock_private_content': 'Desbloquear Contenido Privado',
  'profile.private_content_description': 'Suscríbete para acceder a fotos exclusivas, videos y servicios especiales.',
  'profile.view_private_content': 'Ver Contenido Privado',
  'profile.subscribe_now': 'Suscríbete Ahora',
  'profile.private_content_locked': 'Contenido Privado Bloqueado',
  'profile.private_content_subscription_needed': 'Suscríbete para desbloquear el contenido exclusivo y los servicios de esta escort',
  'profile.view_all_services': 'Ver Todos los Servicios',
  'profile.teaser_upgrade_message': 'Tienes acceso Teaser. Actualiza a Regular para ver todo el contenido',
  'profile.upgrade_now': 'Actualizar Ahora',
  
  // Translation keys for services and rates
  'profile.time': 'Duración',
  'profile.incall': 'En local',
  'profile.outcall': 'A domicilio',
  'profile.included': 'Incluido',
  'profile.extra': 'Extra',
  'profile.show_less': 'Mostrar Menos',
  'profile.services_description': 'Servicios incluidos en las tarifas estándar o disponibles por un cargo extra.',
  'profile.premium_services_description': 'Servicios digitales premium que puedes comprar por separado sin reservar una cita.',
  'messages.starting_conversation': 'Iniciando conversación',
  'messages.please_wait': 'Por favor, espera mientras configuramos tu chat',
  'messages.conversation_created': 'Conversación creada',
  'messages.send_first_message': 'Ahora puedes enviar tu primer mensaje',
  'messages.error_creating': 'Error al crear la conversación',
  'messages.try_again': 'Por favor, inténtalo de nuevo más tarde',
  'profile.default_bio': 'Acompañante elegante y sofisticada con pasión por el arte y la buena gastronomía.',
  'profile.premium_access': 'Acceso Premium',
  'profile.gender': 'Género',
  'profile.age': 'Edad',
  'profile.nationality': 'Nacionalidad',
  'profile.ethnicity': 'Etnia',
  'profile.eye_color': 'Color de ojos',
  'profile.hair_color': 'Color de cabello',
  'profile.height': 'Altura',
  'profile.unit_cm': 'cm',
  'profile.weight': 'Peso',
  'profile.unit_kg': 'kg',
  'profile.measurements': 'Medidas',
  'profile.cup_size': 'Talla de copa',
  'profile.intimate_area': 'Zona íntima',
  'profile.smoking': 'Fumador/a',
  'profile.drinking': 'Bebedor/a',
  'profile.sexual_information': 'Información Sexual',
  'profile.orientation': 'Orientación',
  'profile.interested_in': 'Interesado/a en',
  'profile.preferences': 'Preferencias',
  'profile.value_couples': 'Parejas',
  'profile.value_singles': 'Solteros/as',
  'profile.experience': 'Experiencia',
  'profile.value_intermediate': 'Intermedia',
  'profile.kinks': 'Fetiches',
  'profile.value_roleplay_lightbdsm': 'Juego de roles, BDSM ligero',
  'profile.limits': 'Límites',
  'profile.value_extreme_illegal': 'Dolor extremo, actividades ilegales',
  'profile.premium_prompt': 'Suscríbete para descubrir sus pequeños secretos',
  'profile.contact_information': 'Información de Contacto',
  'profile.phone': 'Teléfono',
  'profile.alternative_phone': 'Teléfono Alternativo',
  'profile.contact_via': 'Contactar Vía',
  'profile.available': 'Disponible',
  'profile.hours': 'Horario',
  'profile.registered_date_prefix': 'Registrado/a el',
  'profile.today': 'Hoy',
  'profile.whatsapp': 'WhatsApp',
  'profile.value_available': 'Disponible',
  'profile.city': 'Ciudad',
  'profile.contact_instructions': 'Por favor, indica por SMS tu edad, origen y duración deseada.',
  'profile.call_button': 'Llamar',
  'profile.day_monday': 'Lunes',
  'profile.day_tuesday': 'Martes',
  'profile.day_wednesday': 'Miércoles',
  'profile.day_thursday': 'Jueves',
  'profile.day_friday': 'Viernes',
  'profile.day_saturday': 'Sábado',
  'profile.day_sunday': 'Domingo',
  
  // Añadiendo claves que faltaban
  'years': 'años',
  'last_online': 'Última conexión',
  'default_bio': 'Acompañante elegante y sofisticada con pasión por el arte y la buena gastronomía.',
  'booking': 'Reservar',
  'contact_availability': 'Contacto y Disponibilidad',
  'send_message': 'Enviar Mensaje',
  'working_hours': 'Horario laboral',
  'service': 'Servicio',
  'status': 'Estado',
  'no_premium_services': 'No hay servicios premium disponibles',
  'profile.private_access': 'Acceso Privado',

  // Keys from logs
  'profile.rates_incall': 'En local',
  'profile.rates_outcall': 'A domicilio',
  'profile.rates_special': 'Especial',
  'profile.rates_note': 'Los precios pueden variar. Contactar para más detalles.',
  'profile.no_slots_available': 'No hay horarios disponibles',
  'profile.select_rate': 'Seleccionar una tarifa',
  
  // Rate durations from logs
  'profile.rate_30min': '30 min',
  'profile.rate_1hour': '1 hora',
  'profile.rate_2hours': '2 horas',
  'profile.rate_overnight': 'Noche completa',
  'profile.rate_weekend': 'Fin de semana',

  // Rate category selection
  'profile.select_category': 'Tipo de encuentro',
};
